import { useParams } from "react-router-dom";
import { Clock, Check } from "lucide-react";
import { PLANNED } from "../lib/nav";

export default function PlannedPage() {
  const { key } = useParams();
  const p = PLANNED[key];
  if (!p) return null;
  return (
    <div className="max-w-3xl">
      <p className="eyebrow mb-2">Phase {p.phase} · not yet built</p>
      <h1 className="font-display text-4xl sm:text-5xl mb-6">{p.title}</h1>
      <div className="panel p-6 border-amber-500/30 bg-amber-500/5 flex gap-3 mb-8" data-testid="planned-notice">
        <Clock className="text-amber-400 shrink-0" size={18} />
        <p className="text-sm text-slate-300">This module is scheduled for Phase {p.phase}. It is intentionally not shown as working until it has been implemented and tested. Your manuscripts and versions created now will feed directly into it.</p>
      </div>
      <p className="text-sm text-slate-400 mb-3">Planned scope:</p>
      <ul className="space-y-2">
        {p.points.map((x) => <li key={x} className="flex gap-2 text-sm text-slate-300"><Check size={16} className="text-slate-600 mt-0.5 shrink-0" />{x}</li>)}
      </ul>
    </div>
  );
}
